export default "__VITE_ASSET__62dd8540__"